import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  captureInstallPrompt,
  enforceHttps,
  injectCspMeta,
  initSentry,
} from "@dwelldrop/shared";
import { setZXingModuleOverrides } from "@yudiel/react-qr-scanner";
import App from "./App";

// ─── Serve WASM locally to satisfy CSP ──────────────────────────────────────
setZXingModuleOverrides({
  locateFile: (path: string) => `/${path}`,
});

// ─── Monitoring bootstrap ───────────────────────────────────────────────────
initSentry({ appName: "venue", dsn: import.meta.env.VITE_SENTRY_DSN, environment: import.meta.env.MODE, isProd: import.meta.env.PROD });

// ─── Security bootstrap ─────────────────────────────────────────────────────
enforceHttps();

captureInstallPrompt();

injectCspMeta({
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  extraScriptSrc: ["'wasm-unsafe-eval'"],
});

if (import.meta.env.DEV) {
  import("react-grab");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
